export default __webpack_public_path__ + "static/media/img-1.0f021934.png";